module.exports = __webpack_public_path__ + "static/media/Cooking.db472ab7.jpg";